import httpManager from "@/app/shared/utils/httpManager";
/**
 * Eliminar una etiqueta por identificador.
 *
 * @param {number} tagId Identificador de la etiqueta.
 */
export async function deleteTag(tagId) {
  await httpManager.delete(`/tickets/tags/${tagId}/`);
}
